import React, { useEffect, useState } from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import '../index.css';
import axios from 'axios';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';

// Register the required components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);

const Dashboard = () => {
  const [data, setData] = useState({
    totalGallonsOver16: 0,
    totalGallonsUnder16: 0,
    totalGallonsUnder14: 0,
    wineDistribution: [],
    vintageDistribution: [], // New state for vintage data
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('/api/dashboard');
        console.log('Received data:', response.data);
        setData(response.data);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };
    fetchData();
  }, []);

  // Bar chart data for varietals
  const barChartData = {
    labels: data.wineDistribution.map((wine) => wine.varietal || 'Unknown'),
    datasets: [
      {
        label: 'Total Gallons by Varietal',
        data: data.wineDistribution.map((wine) => wine.totalGallons || 0),
        backgroundColor: 'rgba(75,192,192,0.6)',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 1,
      },
    ],
  };

  // Bar chart data for vintages
  const vintageChartData = {
    labels: data.vintageDistribution?.map((item) => item.vintage || 'Unknown'),
    datasets: [
      {
        label: 'Total Gallons by Vintage',
        data: data.vintageDistribution?.map((item) => item.totalGallons || 0),
        backgroundColor: 'rgba(153,102,255,0.6)',
        borderColor: 'rgba(153,102,255,1)',
        borderWidth: 1,
      },
    ],
  };

  // Pie chart data
  const pieChartData = {
    labels: ['Over 16%', '14-16%', 'Under 14%'],
    datasets: [
      {
        data: [
          Number(data.totalGallonsOver16) || 0,
          Number(data.totalGallonsUnder16) || 0,
          Number(data.totalGallonsUnder14) || 0,
        ],
        backgroundColor: [
          'rgba(54,162,235,0.6)',
          'rgba(255,206,86,0.6)',
          'rgba(255,99,132,0.6)',
        ],
      },
    ],
  };

  const chartOptions = {
    plugins: {
      legend: {
        position: 'bottom',
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const value = context.raw || 0;
            const numericValue = Number(value);
            if (isNaN(numericValue)) {
              return `${context.label}: 0 gallons`;
            }
            return `${context.label}: ${numericValue.toFixed(2)} gallons`;
          },
        },
      },
    },
  };

  return (
    <div className="container mt-4">
      <h3>Dashboard</h3>
      <div className="row mb-4">
        <div className="col-md-6">
          <h5>Gallons by Varietal</h5>
          <Bar data={barChartData} options={chartOptions} />
        </div>
        <div className="col-md-6">
          <h5>Alcohol Distribution</h5>
          <Pie data={pieChartData} options={chartOptions} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <h5>Gallons by Vintage</h5>
          <Bar data={vintageChartData} options={chartOptions} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;